<template>
  <div class="main-content">
    <div class="card p-2">
      <!-- TOPO -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="m-0">Aprovações</h5>

        <div class="d-flex gap-2">
          <button class="btn btn-outline-secondary btn-sm" @click="goList">
            Voltar para fila
          </button>

          <button class="btn btn-outline-primary btn-sm" @click="refresh">
            <i class="fa fa-refresh"></i> Atualizar
          </button>

          <button class="btn btn-light btn-sm" @click="clearDone">
            Limpar finalizados
          </button>
        </div>
      </div>

      <div v-if="error" class="alert alert-danger p-2 mb-2">
        {{ error }}
      </div>

      <!-- KANBAN -->
      <div class="kanban">
        <div v-for="col in columns" :key="col.key" class="kanban-col">
          <div class="kanban-col-header">
            <div class="col-title">{{ col.title }}</div>
            <div class="col-count">{{ itemsBy(col.key).length }}</div>
          </div>

          <div class="kanban-col-body">
            <div
              v-for="card in itemsBy(col.key)"
              :key="card.id"
              class="wfr-card"
              :class="'bd-' + col.key"
            >
              <div class="wfr-top">
                <div class="wfr-code">#{{ card.flow_id }}</div>

                <span class="pill" :class="'st-' + col.key">
                  {{ col.pill }}
                </span>
              </div>

              <div class="wfr-title">{{ card.title || "—" }}</div>

              <div class="wfr-sub">
                <i class="fa fa-tag"></i>
                <span>{{ card.tag || "—" }}</span>
              </div>

              <div class="wfr-meta">
                <div class="meta-line">
                  <i class="fa fa-user"></i>
                  <span>{{ card.requester || "—" }}</span>
                </div>

                <div class="meta-line">
                  <i class="fa fa-clock-o"></i>
                  <span>{{ card.opened_at || "—" }}</span>
                </div>

                <div class="meta-line">
                  <i class="fa fa-building"></i>
                  <span>{{ card.department || "—" }}</span>
                </div>

                <div class="meta-line">
                  <i class="fa fa-sitemap"></i>
                  <span>{{ card.step_label || "Etapa não informada" }}</span>
                </div>
              </div>

              <div class="card-actions">
                <button
                  class="icon-btn btn-view"
                  title="Visualizar"
                  @click="view(card)"
                >
                  <i class="fa fa-eye"></i>
                </button>
              </div>

              <div class="wfr-actions" v-if="col.key === 'pending'">
                <button
                  class="btn btn-success btn-sm"
                  @click="approve(card)"
                  :disabled="savingId === card.id"
                >
                  <i class="fa fa-check"></i> Aprovar
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  @click="reject(card)"
                  :disabled="savingId === card.id"
                >
                  <i class="fa fa-times"></i> Reprovar
                </button>
              </div>
            </div>

            <div v-if="itemsBy(col.key).length === 0" class="empty-col">
              Sem itens
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { key: "pending", title: "Pendentes", pill: "Pendente" },
        { key: "approved", title: "Aprovados", pill: "Aprovado" },
        { key: "rejected", title: "Reprovados", pill: "Reprovado" },
      ],

      loading: false,
      error: "",
      savingId: null,
      approvals: [],
    };
  },

  async mounted() {
    await this.fetchApprovals();
  },

  methods: {
    itemsBy(status) {
      return this.approvals.filter((x) => x.status === status);
    },

    goList() {
      this.$router.push({ name: "list-flow" });
    },

    async refresh() {
      await this.fetchApprovals();
    },

    clearDone() {
      this.approvals = this.approvals.filter(
        (x) => x.status !== "approved" && x.status !== "rejected"
      );
    },

    formatDate(iso) {
      if (!iso) return "—";
      const d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      return d.toLocaleString("pt-BR");
    },

    getCurrentStep(approval, flow) {
      return (
        flow?.current_step_order ||
        approval.current_step_order ||
        approval.flow_current_step_order ||
        approval.transition?.step_order ||
        1
      );
    },

    getTotalSteps(approval, flow) {
      if (Array.isArray(flow?.transitions) && flow.transitions.length) {
        return flow.transitions.length;
      }

      return approval.total_steps || approval.flow_total_steps || 0;
    },

    async fetchApprovals() {
      try {
        this.loading = true;
        this.error = "";

        const apiBase = this.$store.state.api;
        const ENDPOINT = "flow-approvals";

        const res = await this.$http.get(apiBase + ENDPOINT, {
          params: { mine: 1 },
        });

        const data = Array.isArray(res.data?.data)
          ? res.data.data
          : res.data || [];


        const approvalsWithFlow = await Promise.all(
          data.map(async (a) => {
            let flow = a.flow || null;

            if (!flow && a.flow_id) {
              try {
                const flowRes = await this.$http.get(apiBase + "flows/" + a.flow_id);
                flow = flowRes.data?.data || flowRes.data || null;
              } catch (err) {
                console.error("Erro ao buscar flow", a.flow_id, err);
              }
            }

            const currentStep = this.getCurrentStep(a, flow);
            const totalSteps = this.getTotalSteps(a, flow);

            return {
              id: a.id,
              flow_id: a.flow_id,

              title: flow?.title || a.flow_title || a.title || "",
              tag: flow?.tag || a.flow_tag || a.tag || "",

              requester:
                a.requester_name ||
                a.requester ||
                flow?.openedBy?.name ||
                flow?.opened_by_name ||
                "—",

              opened_at: this.formatDate(
                a.opened_at || a.created_at || flow?.created_at || ""
              ),

              department:
                a.department_name ||
                a.transition?.department?.name ||
                flow?.ownerDepartment?.name ||
                "—",

              status: a.status || "pending",

              current_step: currentStep,
              total_steps: totalSteps,
              step_label: totalSteps
                ? `Etapa ${currentStep} de ${totalSteps}`
                : `Etapa ${currentStep}`,
            };
          })
        );

        this.approvals = approvalsWithFlow;
      } catch (e) {
        console.error(e);
        this.error =
          e?.response?.data?.message ||
          "Não consegui carregar suas aprovações.";
      } finally {
        this.loading = false;
      }
    },

    view(card) {
      this.$router.push(`/Flow/view/${card.flow_id}`);
    },

    edit(card) {
      this.$router.push(`/Flow/edit/${card.flow_id}`);
    },

    async approve(card) {
      try {
        this.savingId = card.id;
        this.error = "";

        const apiBase = this.$store.state.api;

        await this.$http.post(apiBase + `flow-approvals/${card.id}/approve`);

        await this.fetchApprovals();
        alert(`Aprovado: #${card.flow_id}`);
      } catch (e) {
        console.error(e);
        this.error =
          e?.response?.data?.message || "Erro ao aprovar a solicitação.";
      } finally {
        this.savingId = null;
      }
    },

    async reject(card) {
      try {
        this.savingId = card.id;
        this.error = "";

        const comment = prompt("Informe o motivo da reprovação:");
        if (!comment || !comment.trim()) {
          this.savingId = null;
          return;
        }

        const apiBase = this.$store.state.api;

        await this.$http.post(apiBase + `flow-approvals/${card.id}/reject`, {
          comment: comment.trim(),
          rejection_type: "global",
          return_to_transition_id: null,
        });

        await this.fetchApprovals();
        alert(`Reprovado: #${card.flow_id}`);
      } catch (e) {
        console.error(e);
        this.error =
          e?.response?.data?.message || "Erro ao reprovar a solicitação.";
      } finally {
        this.savingId = null;
      }
    },
  },
};
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}

.kanban {
  display: grid;
  grid-template-columns: repeat(3, minmax(220px, 1fr));
  gap: 14px;
  align-items: start;
}

.kanban-col {
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.kanban-col-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #e5e7eb;
  font-weight: 700;
  color: #374151;
}

.col-count {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: #fff;
}

.kanban-col-body {
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 320px;
}

.wfr-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  border-top-width: 3px;
}

.bd-pending {
  border-top-color: #f1c21b;
}
.bd-approved {
  border-top-color: #24a148;
}
.bd-rejected {
  border-top-color: #da1e28;
}

.wfr-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.wfr-code {
  font-weight: 900;
  color: #111827;
}

.wfr-title {
  margin-top: 6px;
  font-weight: 800;
  color: #111827;
}

.wfr-sub {
  margin-top: 6px;
  font-size: 12px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.wfr-meta {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.meta-line {
  font-size: 12px;
  color: #374151;
  display: flex;
  gap: 8px;
  align-items: center;
}

.meta-line i {
  width: 14px;
  text-align: center;
  color: #6b7280;
}

.wfr-actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.pill {
  font-size: 11px;
  font-weight: 800;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
}

.st-pending {
  background: #fff7e6;
  color: #a16207;
}
.st-approved {
  background: #e9fff0;
  color: #15803d;
}
.st-rejected {
  background: #ffe3e3;
  color: #b91c1c;
}

.empty-col {
  margin-top: 10px;
  font-size: 12px;
  color: #6b7280;
  text-align: center;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}

.icon-btn {
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 6px;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid #ccc;
  margin: 0;
  line-height: 1;
}

.icon-btn i {
  font-size: 12px;
  color: #111;
}

.btn-view {
  border-color: #f1c21b;
}

.btn-edit {
  border-color: #24a148;
}

.icon-btn:hover {
  filter: brightness(0.95);
  transform: translateY(-1px);
  transition: 0.12s;
}
</style>